<!--ptw总结-->
<template>
  <div v-if="dataNotNull" key="1" class="defectstatusDiv" style="width: 100%; height: 100%">
    <div class="container1" style="margin:15px 0 0 20px; height: 100%;"></div>
  </div>
  <div v-else key="2" style="width: 100%; height: 100%;">
    <div class="title_defect_status">Defects Closure Status</div>
    <div class="zero_defect_status">No Data !</div>
  </div>
</template>

<script>
import echarts from 'echarts'
import axios from 'axios'

export default {
  props: ['project_id'],
  name: "defect_status",
  data() {
    return {
      my_project_id: this.project_id,
      color: this.$store.state.color.chart_color,
      myChart: null,
      name: "defectstatuss",
      dataNotNull: true,
      proj_dict: {
        "1404": "P00056",
        "1002": "P00034",
        "212": "P00005",
        "249": "P00018"
      }
    }
  },

  methods: {
    init() {
      // this.$root.charts.push(this.myChart)
      window.addEventListener("resize", function () {
        this.myChart.resize()
      }.bind(this))
    },
    analysisResult(result) {
      var legends = []
      var checkstatus = []
      var assists = []
      var totle = []
      var total = 0
      var assist = 0

      for (var i in result) {
        var status = result[i].status
        var count = result[i].count
        legends.push(status)
        checkstatus.push({name: status, value: count})
        total += parseInt(count)
      }
      total *= 1.2
      assist = total / 8
      for (var i in result) {
        var status = result[i].status
        var count = parseInt(result[i].count) + assist
        assists.push({name: status.substring(0, 18), value: count})
        totle.push({name: status.substring(0, 18), value: total})
      }
      return {legends: legends, checkstatus: checkstatus, assists: assists, totle: totle, assist: assist}
    }
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
  },
  mounted() {
    let that = this
    var name = window.localStorage.getItem('token_key')
    if ("videmo" == name) {
      this.my_project_id = "212"
    }
    this.myChart = echarts.init(document.querySelector('.defectstatusDiv .container1'))
    this.myChart.setOption({
      title: {
        text: 'Defects Closure Status',
        textStyle: {
          color: '#FFF',
          fontSize: 16
        }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'none'
        },
        formatter: function (params) {
          return params[1].name + ':  ' + Math.round(params[2].value * 120 / params[0].value) + '%';
        }
      },
      grid: {
        left: 90
      },
      xAxis: {
        type: 'value',
        show: false,
        axisLabel: {
          formatter: '{value}'
        }
      },
      yAxis: {
        type: 'category',
        inverse: true,
        data: [],
        axisLine: {
          show: true,
          lineStyle: {
            color: '#6CF'
          }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          margin: 15,
          show: true,
          textStyle: {
            color: '#FFF',
          }
        },
        splitLine: {
          show: false
        }
      },
      series: [
        {
          name: '总计',
          type: 'bar',
          barGap: '-100%',
          barWidth: '60%',
          label: {
            normal: {
              show: false,
              color: '#6cf',
              position: 'insideRight',
            }
          },
          itemStyle: {
            normal: {
              color: '#00000000',
              borderColor: '#999',
              borderWidth: '0',
            }
          },
          data: []
        },
        {
          name: '总计',
          type: 'bar',
          barGap: '-100%',
          barWidth: '60%',
          label: {
            normal: {
              show: true,
              color: '#6cf',
              position: 'insideRight',
              formatter: '{c}'
            }
          },
          itemStyle: {
            normal: {
              color: '#00000000',
            }
          },
          data: []
        },
        {
          name: 'Ongoing',
          type: 'bar',
          barWidth: '60%',
          data: [],
          label: {
            normal: {
              show: false,
              formatter: '{b}'
            }
          },
          itemStyle: {
            normal: {
              color: function (params) {
                return that.color[params.dataIndex]
              },
            }
          },
        }
      ]
    })
    this.myChart.showLoading({
      text: '',
      color: '#66CCFF',
      maskColor: 'rgba(255, 255, 255, 0)',
    });
    var proj_id = ''
    if (this.proj_dict[this.my_project_id]) {
      proj_id = this.proj_dict[this.my_project_id]
    } else {
      proj_id = this.my_project_id
    }
    let postData = {
      proj_id: proj_id,
      user: window.localStorage.getItem("token_key"),
      token: window.localStorage.getItem('token')
    }
    axios.post(this.$store.getters.getDevServer + "DBProjObsStatus", postData).then(resp => {
      var errNo = resp.data.errno
      var errStr = resp.data.errstr_cn
      this.myChart.hideLoading()
      if (errNo == "0") {
        this.dataNotNull = true
        var legends = []
        var defectstatuss = []
        var result = resp.data.result;
        var data = this.analysisResult(result)
        this.myChart.setOption({
          yAxis: {
            data: data.legends,
          },
          series: [{
            data: data.totle
          },
            {
              data: data.assists,
              label: {
                normal: {
                  show: true,
                  color: '#6cf',
                  position: 'insideRight',
                  formatter: function (params) {
                    return parseInt(params.value) - parseInt(data.assist);
                  }
                }
              },
            },
            {
              data: data.checkstatus
            }
          ]
        })
      } else {
        this.dataNotNull = false
      }
    }).catch(error => {
      alert(error)
      this.myChart.hideLoading()
      this.dataNotNull = false
    })
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.title_defect_status
  width 100%
  height 10%
  text-align left
  font-weight bold
  font-size 16px
  color #FFF
  padding-top 17px
  padding-left 25px

.zero_defect_status
  width 100%
  height 100%
  text-align center
  padding-top 15%
  font-size 28px
  color #6CF
</style>



// WEBPACK FOOTER //
// src/components/quality/defect_status.vue